module.exports = __webpack_public_path__ + "static/media/qrEnollmentCode.5df5d466.svg";